import adModal from '../../../../library/admodel'

// 我的书架跳转到页码页，旧书籍展示移除书架弹窗
export function showRemoveBookRackModal(removeCallback) {
  return adModal({
    img: 'https://img01.yzcdn.cn/upload_files/2021/12/09/Fq5R2GmCE8jivMEh0XOudpsgQDJB.png',
    hotspot: [
      {
        left: '15',
        right: '15',
        bottom: '10',
        top: '76',
        click: removeCallback
      }
    ],
    clickOverlay: false,
    close() {
      window.history.back()
    }
  })
}
